var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-text',{staticClass:"text-center mt-2"},[_c('span',[_vm._v(" Problèmes de connexion? ")]),_c('br'),_c('b-link',{attrs:{"href":("mailto:" + _vm.supportEmail)}},[_c('span',[_vm._v("Contactez-nous")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }